






















































import Vue from "vue";
import { bus } from "@/main";
import { requestFanAccess } from "@/helpers/api";

export default Vue.extend({
  name: "PlayerAccessRequest",
  data() {
    return {
      email: "",
      playerName: "",
      showForm: false,
      loading: false
    };
  },
  methods: {
    async requestAccess() {
      this.loading = true;
      const resp = await requestFanAccess(this.email, this.playerName);
      this.showForm = false;
      this.loading = false;
      if (resp.data.success) {
        bus.$emit("successSnack", resp.data.message);
      } else {
        bus.$emit(
          "errorSnack",
          "Error requesting access, please reach out to your coach directly."
        );
      }
    }
  }
});
